import { PRODUCT_NAME } from '../../content/provenance'

/**
 * The MUSTER wordmark. It comes in a light-theme and a dark-theme artwork, and
 * the one matching the theme in force is shown (index.css, brand-logo-*). A
 * `fixed` mark stays on one artwork whatever the theme, for a band that keeps
 * its own colors in both, such as the footer.
 */
export default function Wordmark({ className = 'h-7 w-auto', fixed }: { className?: string; fixed?: 'light' | 'dark' }) {
  const image = (variant: 'light' | 'dark', extra: string) => (
    <img src={`/images/muster-logo-${variant}.svg`} alt={PRODUCT_NAME} width={546} height={78} className={`${extra} ${className}`} />
  )
  return fixed ? (
    image(fixed, '')
  ) : (
    <>
      {image('light', 'brand-logo-light')}
      {image('dark', 'brand-logo-dark')}
    </>
  )
}
